<template>
    <div>
        <div class="myHead">
            <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/responsibility'}">目标责任管理</el-breadcrumb-item>
                <el-breadcrumb-item>添加计划</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-form :model="form" :rules="rules" label-width="100px" class="demo-ruleForm" style="width:80%;margin:0 auto">
            <el-form-item label="计划名称" style="margin-bottom: 20px;" prop="region">
                <div class="block">
                    <el-input v-model="form.planName" id="remainder"  size="small" style="width: 200px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="计划人" style="margin-bottom: 20px;" prop="region">
                <div class="block">
                    <el-input v-model="form.planUser" id="remainder"  size="small" style="width: 200px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="起始时间" style="margin-bottom: 20px;" prop="region">
                <div class="block">
                    <el-input v-model="form.starTime" id="remainder"  size="small" style="width: 200px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="结束时间" style="margin-bottom: 20px;" prop="region">
                <div class="block">
                    <el-input v-model="form.endTime" id="remainder"  size="small" style="width: 200px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="责任单位" style="margin-bottom: 20px;" prop="region">
                <div class="block">
                    <el-input v-model="form.respDep" id="remainder"  size="small" style="width: 200px;"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="计划内容" style="margin-bottom: 20px;" prop="region">
                <div class="block">
                    <el-input v-model="form.planContent" id="remainder"  size="small" style="width: 200px;"></el-input>
                </div>
            </el-form-item>

        </el-form>
        <div>
            <el-button type="primary" class="addBtn" @click="submitForm()">确定</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                form: {},
                rules: {
                    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                },
                options: [],
                getObj: {},
                isShowBtn: true,
                isShowBtn2: true,
                emergeData: [],
                emergeData2: [],
                fileList:[]
            };
        },
        methods: {
            submitForm(){
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").saveGoalPlan)
                    .openLoad()
                    .startPost(this.form)
                    .then((res) => {
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success",
                        });

                        this.$router.push({
                            path: "/processManager/responsibility",
                        });
                    });


            },

        },
        created() {

        },
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }
    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }

    .el-divider__text {
        font-size: 20px !important;
    }
</style>
